import { render, staticRenderFns } from "./WAutocomplete.vue?vue&type=template&id=85bd8582&"
import script from "./WAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports